export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ../~/@ant-design/icons-react/es/index.js
// module id = 616
// module chunks = 1